module.exports = __webpack_public_path__ + "static/media/vote-yea.95cde216.svg";